import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

try {
    const apiKey = document.querySelector('[name="apiKey"]');
    const authDomain = document.querySelector('[name="authDomain"]');
    const projectId = document.querySelector('[name="projectId"]');
    const storageBucket = document.querySelector('[name="storageBucket"]');
    const messagingSenderId = document.querySelector('[name="messagingSenderId"]');
    const appId = document.querySelector('[name="appId"]');
    const measurementId = document.querySelector('[name="measurementId"]');

    const setUpDeviceRoute = document.querySelector('[name="device-route"]').content;
    const csrfToken = document.querySelector('[name="csrf-token"]').content;
    let app, messaging;

    const firebaseConfig = {
        apiKey: apiKey.content,
        authDomain: authDomain.content,
        projectId: projectId.content,
        storageBucket: storageBucket.content,
        messagingSenderId: messagingSenderId.content,
        appId: appId.content,
        measurementId: measurementId.content
    };

    if (projectId.content) {

        app = initializeApp(firebaseConfig);
        messaging = getMessaging(app);

        getToken(messaging)
            .then((currentToken) => {
                if (currentToken) {

                    fetch(setUpDeviceRoute, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'X-Requested-With': 'XMLHttpRequest',
                            'X-CSRF-Token': csrfToken
                        },
                        body: JSON.stringify({
                            'push_token': currentToken
                        })
                    });

                } else {
                    console.log('No registration token available. Request permission to generate one.');
                }
            }).catch((err) => {
            console.log('An error occurred while retrieving token. ', err);
        });

        onMessage(messaging, function (payload) {
            setTimeout(() => {
                console.log('Message received. ', payload, Date.now());
    
                const messageId = payload.messageId;
    
                console.log(localStorage.getItem(messageId));
    
                if (localStorage.getItem(messageId)) {
                    console.log('returned');
                    setTimeout(() => {
                        localStorage.removeItem(messageId);
                    }, 2000);
                    return;
                }
                            
                localStorage.setItem(messageId, "shown");
    
                const title = payload.notification.title;
                const options = {
                    body: payload.notification.body,
                    icon: "/img/logo/notify-logo.svg",
                };
    
                let notification = new Notification(title, options);
    
                notification.addEventListener("click", function (event) {
                    //window.location.href = payload.data.url;
                    window.open(payload.data.url, "_blank").focus();
                });
            }, Math.floor(Math.random() * 1000))
        });
    }
} catch (e) {
    console.warn(e)
}
